module.exports = __webpack_public_path__ + "static/img/brees-2016-img-in-copy.59b9251.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-img-in-copy.jpg
// module id = HoMa
// module chunks = 1